export type PolicyDocumentType = {
  label: string;
  value: number;
};

export const PolicyDocumentTypes: PolicyDocumentType[] = [
  {
    label: 'Name Change',
    value: 1,
  },
  {
    label: 'Ownership Change',
    value: 2,
  },
  {
    label: 'Beneficiary Change Request',
    value: 3,
  },
  {
    label: 'Life Policy Change & Service Request',
    value: 4,
  },
  {
    label: 'Premium and Billing Change Request',
    value: 5,
  },
  {
    label: 'Policy Change & Service Request',
    value: 6,
  },
  {
    label: 'HIPAA Authorization - New York',
    value: 7,
  },
  {
    label: 'HIPAA Authorization',
    value: 8,
  },
  {
    label: 'Claim Document',
    value: 9,
  },
];
